<div class="container-main">
  <div>
    <div class="row content margin-top">
      <div class="col-4">
        <app-text-search-filter [(form)]="form"></app-text-search-filter>
      </div>
      <div class="col-8">
        <div class="filter-div margin-center">
          <mat-select
            class="input-select margin-center"
            [(ngModel)]="optionSelect"
          >
            <mat-option
              (click)="search()"
              *ngFor="let option of optionTextSearch"
              [value]="option"
              >{{ option }}</mat-option
            >
          </mat-select>
          <input
            class="input-text margin-center"
            matInput
            [(ngModel)]="text"
            placeholder="Buscar..."
          />
          <button (click)="search()" class="button margin-center">
            Buscar
          </button>
        </div>
        <div *ngIf="optionSelect != 'Casos'" class="row margin-top">
          <card-text-search
            class="col-4"
            *ngFor="let tarea of content.tareas"
            [tarea]="tarea"
          ></card-text-search>
        </div>
        <div *ngIf="optionSelect != 'Tareas'" class="row margin-top">
          <card-text-search
            class="col-4"
            *ngFor="let caso of content.casos"
            [caso]="caso"
          ></card-text-search>
        </div>
      </div>
    </div>
  </div>
</div>
